(function () {
  if (window.__avMedia) return;
  window.__avMedia = true;
  function play(v) {
    if (v.preload !== 'auto') v.preload = 'auto';
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function init() {
    var vids = [].slice.call(document.querySelectorAll('video.av-lazy-video'));
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { if (v.hasAttribute('data-autoplay')) play(v); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.hasAttribute('data-autoplay')) play(v);
          else if (v.preload === 'none') v.preload = 'metadata';
        } else if (!v.paused && v.hasAttribute('data-autoplay')) {
          v.pause();
        }
      });
    }, { rootMargin: '300px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
